import genererMateriel from '@/services/gabed/materiel/genererMateriel';
import fillMaterielWithData
  from '@/services/import/patrimoine/generation/materiel/fillMaterielWithData';

export default function generationMateriel(materielReference, informationApiReference) {
  const materiel = genererMateriel();
  return fillMaterielWithData(materielReference, materiel, informationApiReference);
}
